import * as React from 'react';
import { inject, observer } from 'mobx-react';
import styled from 'styled-components';
import { colors } from 'kaizen-ui-colors/lib';
import { IStore } from '../../domain/store';
import { Dropdown, IDropdownItem } from './Dropdown';
import { GoalListItem } from './GoalListItem';
import ChevronDownSVG from './Icon/ChevronDown';

interface IProps {
  store?: IStore;
}

const CurrentGoal = styled.div`
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  height: 38px;
  cursor: pointer;
  user-select: none;
  background-color: #fff;
  border: 1px solid ${colors.lithium_light__e2e6ef};
  font-size: 1rem;
  border-radius: 4px;
  padding: 1px 8px 1px 16px;
  color: currentColor;
  outline: none;
`;

const ChevronDown = styled.div`
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

@inject('store')
@observer
export class GoalSelector extends React.Component<IProps, {}> {
  private store: IStore;

  constructor(props: IProps) {
    super(props);
    this.store = props.store!;
    this.onChange = this.onChange.bind(this);
  }

  public onChange(e: React.SyntheticEvent<HTMLElement>, selectedKey: string) {
    const { goalStore } = this.store;
    e.stopPropagation();
    goalStore.setSelectedGoalId(selectedKey);
  }

  public render() {
    const { goalStore } = this.store;

    const TriggerComponent = (
      <CurrentGoal>
        {goalStore.selectedGoal ? (
          <React.Fragment>
            <GoalListItem
              id={goalStore.selectedGoal.id}
              type={goalStore.selectedGoal.type}
              title={goalStore.selectedGoal.title}
            />
            <ChevronDown>
              <ChevronDownSVG size={16} />
            </ChevronDown>
          </React.Fragment>
        ) : null}
      </CurrentGoal>
    );

    const Items: IDropdownItem[] = [];
    goalStore.goalList!.map(goal => {
      if (goal.id !== goalStore.selectedGoalId) {
        Items.push({
          key: goal.id,
          component: <GoalListItem id={goal.id} type={goal.type} title={goal.title} />,
        });
      }
    });

    return (
      <Dropdown placement={'bottom-start'} triggerComponent={TriggerComponent} items={Items} onChange={this.onChange} />
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/presentation/component/GoalSelector.tsx